import { render } from "./NomalContainer.vue?vue&type=template&id=b47ab38e"
import script from "./NomalContainer.vue?vue&type=script&lang=ts"
export * from "./NomalContainer.vue?vue&type=script&lang=ts"
script.render = render

export default script